<template>
<div class="row">
  <div
    class="col-xs-12"
    style="margin-bottom: 15px;"
  >
    <el-collapse class="dashboard-collapse">
      <el-collapse-item name="1">
        <template slot="title">
        Filtros:
        <small style="margin-left: 20px;">
          {{ textTagsFilters }}{{ rangeDate.length > 0 && textTagsFilters !== '' ? ' e entre (' : '' }}{{ rangeDate.length > 0 ? $moment(rangeDate[0]).format('LL') + ' e ' + $moment(rangeDate[1]).format('LL') + ')' : '' }}
        </small>
        </template>
        <dashboard-form-filters @filter="$emit('filter')"/>
      </el-collapse-item>
    </el-collapse>
  </div>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import DashboardFormFilters from 'src/components/Trg/Filters/DashboardFormFilters'

export default {
  name: 'DashboardFilter',
  components: {
    DashboardFormFilters
  },

  computed: {
    ...mapGetters({
      rangeDate: 'rangeDate'
    }),
    ...mapGetters('tags', {
      tags: 'tags',
      tagsSelected: 'selecteds',
      textTagsFilters: 'textTagsFilters'
    })
  }
}
</script>

<style>
  .dashboard-collapse,
  .dashboard-collapse > div,
  .dashboard-collapse > .el-collapse-item div {
    background-color: #ffffff !important;
  }

  .card-content .title {
    margin-bottom: 10px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tag {
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .tag span {
    margin-right: 20px;
  }

  .tag .date {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/DashboardFilter.vue